/* eslint-disable max-len */
import React from "react";

type SVGRProps = {
  title?: string;
}

export const BrokenImage = ({
    title,
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        fill="none"
        height="37"
        role="presentation"
        viewBox="0 0 29 37"
        width="29"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {!!title && <title>{title}</title>}
        <path
            stroke="currentColor"
            d="M28.5 35.028a1 1 0 0 1-1 1h-13V1.972a1 1 0 0 1 1.582-.814l12 8.572a1 1 0 0 1 .418.814v24.484ZM26.5 8.6V3.028m-12 7h4m-4 6h6m-20 6h6m-6 6h6m8-6h9M18.5 36.028v-7a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v7m-10-20h-13a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h13"
        />
    </svg>
);
